import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { is24HoursAfter } from 'src/app/shared/utils/dates';

import { NOTIFICATION_TYPES } from '../../../constants';

type UseAutoTaggedPetitionReturn = { type: (typeof NOTIFICATION_TYPES)['autoTaggedPetition'] } | undefined;
export function useAutoTaggedPetition(): UseAutoTaggedPetitionReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();

	const tags = petition.tagsConnection.nodes;
	const tagsCreatedByModel = tags.filter((tag) => tag.createdByModel);
	const tagsCreatedByModelWithin24Hours = tagsCreatedByModel.filter(
		(tag) => tag.taggingCreatedAt && !is24HoursAfter(new Date(), new Date(tag.taggingCreatedAt)),
	);

	// ALERTS: comment the following block
	if (tagsCreatedByModelWithin24Hours.length === 0) {
		return undefined;
	}

	return { type: NOTIFICATION_TYPES.autoTaggedPetition };
}
